// extracted by mini-css-extract-plugin
module.exports = {"root":"DocSkeleton_root__EdrJ0"};